<template>
  <video
    ref="videoEl"
    :class="['video-layer', { 'video-layer--fixed': fixed }]"
    :style="layerStyle"
    :poster="poster"
    autoplay
    muted
    loop
    playsinline
    preload="none"
  >
    <source :src="src" type="video/mp4" />
  </video>
</template>

<script setup>
import { ref, computed, defineProps, defineExpose } from "vue";
import { useVideoLoader } from "@/composables/useVideoLoader";

const props = defineProps({
  src: { type: String, required: true },
  blendMode: { type: String, default: "screen" },
  opacity: { type: Number, default: 0.3 },
  poster: { type: String, default: "" },
  scrubToScroll: { type: Boolean, default: false },
  fixed: { type: Boolean, default: false },
});

const videoEl = ref(null);
useVideoLoader(videoEl);

const layerStyle = computed(() => ({
  mixBlendMode: props.blendMode,
  opacity: props.opacity,
}));

defineExpose({ videoEl });
</script>

<style scoped>
.video-layer {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  z-index: 1;
}

.video-layer--fixed {
  position: fixed;
  z-index: 0;
}
</style>
